module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/notify.json
// module id = 375
// module chunks = 244195295549694